import * as Yup from "yup";
import {toast} from "react-toastify";
import React, {useEffect, useRef, useState} from "react";
import {useField} from "@unform/core";
import messageTypes from "../../../constants/MessagesTypes";
import {Form} from "@unform/web";
import CustomButton from "../../../components/Form/Button";
import {Link, useHistory} from "react-router-dom";
import {BiArrowBack} from "react-icons/bi";
import {IoMdCheckmark} from "react-icons/io";
import Fieldset from "../../../components/Fieldset";
import CkeckboxInput from "../../../components/Form/Checkbox";
import {edit, getDisciplina, save} from "../../../services/Disciplina";
import InputDate from "../../../components/Form/InputDate";
import {useTranslation} from "react-i18next";
import DivDiagonal from "../../../components/DivDiagonal";
import {
    TradingWrapper,
    ContentArea,
    TradingCard,
    HeaderActions,
    NewTradingButton,
} from "../../Trading/styles";
import {StrategyPageHeader} from "../../Strategy/styles";
import {
    DisciplineFormNarrow,
    DisciplineFieldsetWrap,
    DisciplineErrorFieldWrap,
    DisciplineErrorLabel,
    DisciplineErrorTextarea,
} from "../styles";
import {StyledFormWrapper, ButtonContainer, FormRow} from "../../Trading/New/styles";

const backBtnStyle = {
    background: 'rgba(255, 255, 255, 0.05)',
    border: '2px solid rgba(255, 255, 255, 0.2)',
    color: '#e0e0e0',
    padding: '14px 28px',
    borderRadius: '10px',
    fontWeight: 600,
    transition: 'all 0.3s ease',
};

const saveBtnStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '14px 32px',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    transition: 'all 0.3s ease',
};

function DisciplineErrorDescriptionField({ name, label, placeholder, defaultValue: defaultValueProp }) {
    const textareaRef = useRef(null);
    const { fieldName, defaultValue, registerField, error } = useField(name);

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: textareaRef,
            getValue: (ref) => (ref.current ? ref.current.value : ''),
            setValue: (ref, value) => {
                if (ref.current) ref.current.value = value;
            },
            clearValue: (ref) => {
                if (ref.current) ref.current.value = '';
            },
        });
    }, [fieldName, registerField]);

    return (
        <DisciplineErrorFieldWrap>
            {label ? <DisciplineErrorLabel htmlFor={fieldName}>{label}</DisciplineErrorLabel> : null}
            <DisciplineErrorTextarea
                ref={textareaRef}
                id={fieldName}
                name={fieldName}
                defaultValue={defaultValueProp !== undefined ? defaultValueProp : defaultValue}
                placeholder={placeholder}
            />
            {error ? (
                <span style={{ color: '#ff6b6b', fontSize: '12px', marginTop: '6px', display: 'block' }}>{error}</span>
            ) : null}
        </DisciplineErrorFieldWrap>
    );
}

export default function NewDisciplina({match}) {
    const [saving, setSaving] = useState(false);
    const [fetching, setFetching] = useState(false);
    const [disciplina, setDisciplina] = useState(0);
    const [isManagementFollowed, setManagementFollowed] = useState(null);
    const formRef = useRef(null);
    const history = useHistory();
    const { t } = useTranslation();
    const editId = match.params.id;

    async function handleSubmmit(data) {
        try {
            if (isManagementFollowed === null) {
                toast.warning(t('discipline_alert_is_management_followed'));
                return;
            }

            if (saving) {
                return;
            }

            setSaving(true);
            formRef.current.setErrors({});
            const schema = Yup.object().shape({
                created: Yup.string().required(t('input_required')),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            const formData = new FormData();
            if (data.errorDescription) {
                formData.append('errorDescription', data.errorDescription);
            }

            formData.append('created', data.created);
            formData.append('isManagementFollowed', isManagementFollowed);
            const response =
                disciplina && disciplina.id
                    ? await edit(disciplina.id, formData)
                    : await save(formData);

            if (response && response.status === 200) {
                toast.success(messageTypes.SUCCESS);
                history.push('/disciplina');
            } else {
                toast.error(messageTypes.ERROR_SAVE);
            }
            setSaving(false);

        } catch (err) {
            setSaving(false);
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    useEffect(() => {
        if (!editId) {
            return;
        }
        setFetching(true);
        getDisciplina(editId).then((data) => {
            setDisciplina(data);
            if (data && data.isManagementFollowed !== null && data.isManagementFollowed !== undefined) {
                setManagementFollowed(data.isManagementFollowed === true ? 'true' : 'false');
            }
        }).finally(() => setFetching(false));
    }, [editId]);

    const isEdit = Boolean(disciplina && disciplina.id);
    const showForm = !editId || (disciplina && disciplina.id);

    return (
        <TradingWrapper>
            <DivDiagonal />
            <ContentArea>
                <StrategyPageHeader>
                    <h1>
                        <i className={`fas ${isEdit ? 'fa-edit' : 'fa-plus'}`} aria-hidden="true"/>
                        {' '}
                        {isEdit ? t('discipline_card_edit_title') : t('discipline_card_new_title')}
                    </h1>
                    <HeaderActions>
                        <NewTradingButton as={Link} to="/disciplina">
                            <i className="fas fa-list" aria-hidden="true"/> {t('discipline_card_title')}
                        </NewTradingButton>
                    </HeaderActions>
                </StrategyPageHeader>

                <DisciplineFormNarrow>
                    <TradingCard>
                        {editId && fetching ? (
                            <StyledFormWrapper>
                                <div style={{ textAlign: 'center', padding: '40px 16px', color: 'rgba(255,255,255,0.65)' }}>
                                    {t('loading')}
                                </div>
                            </StyledFormWrapper>
                        ) : showForm ? (
                            <StyledFormWrapper>
                                <Form ref={formRef} onSubmit={handleSubmmit}>
                                    <FormRow>
                                        <InputDate
                                            name="created"
                                            label={t('discipline_label_input_data') + ' *'}
                                            value={(disciplina && disciplina.created) ? new Date(disciplina.created.date) : new Date()}
                                        />
                                    </FormRow>

                                    <DisciplineFieldsetWrap>
                                        <Fieldset textLegend={t('discipline_fieldset_title') + ' *'} className="scheduler-border">
                                            <div className="form-check">
                                                <CkeckboxInput
                                                    labelLight
                                                    id="isManagementFollowed"
                                                    name="isManagementFollowed"
                                                    setValue={setManagementFollowed}
                                                    value={
                                                        disciplina && disciplina.isManagementFollowed !== null && disciplina.isManagementFollowed !== undefined
                                                            ? (disciplina.isManagementFollowed === true ? 'true' : 'false')
                                                            : null
                                                    }
                                                    options={[
                                                        {name: 'yes', value: 'true', label: t('discipline_fieldset_option_1')},
                                                        {name: 'not', value: 'false', label: t('discipline_fieldset_option_2')},
                                                    ]}
                                                />
                                            </div>
                                        </Fieldset>
                                    </DisciplineFieldsetWrap>

                                    {isManagementFollowed === 'false' && (
                                        <FormRow>
                                            <DisciplineErrorDescriptionField
                                                name="errorDescription"
                                                defaultValue={disciplina && disciplina.errorDescription ? disciplina.errorDescription : ''}
                                                label={t('discipline_label_input_management_followed')}
                                                placeholder={t('discipline_label_input_management_followed_placeholder')}
                                            />
                                        </FormRow>
                                    )}

                                    <ButtonContainer>
                                        <Link to="/disciplina" style={{ textDecoration: 'none' }}>
                                            <CustomButton
                                                variant="outlined"
                                                className="btn btn-secondary font-weight-bold text-capitalize mobile-button"
                                                startIcon={<BiArrowBack/>}
                                                style={backBtnStyle}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                                                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                                                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                }}
                                            >
                                                {t('btn_back')}
                                            </CustomButton>
                                        </Link>
                                        <CustomButton
                                            className="btn btn-primary font-weight-bold text-capitalize mobile-button"
                                            loading={saving}
                                            type="submit"
                                            startIcon={<IoMdCheckmark/>}
                                            style={saveBtnStyle}
                                            onMouseEnter={(e) => {
                                                if (!saving) {
                                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                                            }}
                                        >
                                            {t('btn_save')}
                                        </CustomButton>
                                    </ButtonContainer>
                                </Form>
                            </StyledFormWrapper>
                        ) : null}
                    </TradingCard>
                </DisciplineFormNarrow>
            </ContentArea>
        </TradingWrapper>
    );
}
